import { Layout } from "@synota-io/synota-shared-ui";
import { useIsFetching } from "@tanstack/react-query";
import { AppMenu } from "./AppMenu";
import { TopbarContent } from "./TopbarContent";

export const LayoutContainer = () => {
  const isFetching = useIsFetching();

  return (
    <Layout
      disableScroll
      isFetching={Boolean(isFetching)}
      sidebar={<AppMenu />}
      topbar={<TopbarContent />}
    />
  );
};
